import { Component, input } from '@angular/core';

/**
 * Native-Angular port of the AngularJS `ftStat` directive
 * (account-v1/.../components/common/stats/stat.{js,html}). Renders a
 * count value + label; adds `is-zero` class when value is the literal
 * string '0' (matches v1 behavior — the directive used `@`-binding so
 * the value arrived as a string).
 */
@Component({
    selector: 'ft-stat',
    templateUrl: './stat.component.html',
    standalone: false
})
export class FtStatComponent {
    readonly value = input<string | number | null>();
    readonly label = input<string | null>();
}
